<template>
  <div class="mod-mobileverify">
    <a-input
      class="input clearfix"
      :size="size"
      :max-length="6"
      @change="onInputChange"
      @blur="onBlur"
      :placeholder="placeholder"
    >
      <a-button
        v-if="this.cd === 0"
        class="btn-send-code"
        :size="size"
        slot="addonAfter"
        type="primary"
        @click="send"
      >点击发送验证码</a-button>
      <a-button
        v-else
        class="btn-send-code"
        :size="size"
        slot="addonAfter"
        type="primary"
        disabled
      >({{cd}})S后可再次发送</a-button>
    </a-input>
  </div>
</template>

<script>
import { validate } from '@/assets/js/validate'
import { getSmsCode } from '@/apis/common'

export default {
  name: 'l8-mobileverification',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    phone: { type: String, default: '' },
    countryCode: { type: String, default: '86' },
    captcha: { type: Boolean, default: false },
    size: { type: String, default: 'default' },
    placeholder: { type: String, default: '手机验证码' }
  },
  data () {
    return {
      model: '',
      cd: 0,
      timer: null
    }
  },
  created () {
    this.model = this.value
  },
  beforeDestroy () {
    if (this.timer !== null) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    send () {
      if (this.phone.trim().length < 1) {
        this.$message.error('手机号码未输入或不正确')
        return
      }

      if (!this.captcha) {
        this.$message.error('请先通过滑块/图片验证')
        return
      }

      this.processSend()
    },
    async processSend () {
      const { countryCode, phone } = this
      const datas = { phone: phone, countryCode: countryCode, validateSchema: 'sendcode', validateBySelf: true }
      const validRes = await validate('sendcode', datas)
      if (!validRes.valid) {
        this.$message.error(validRes.errors[0].message)
        return
      }
      this.startTimer()

      try {
        await getSmsCode({ phone })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    startTimer () {
      if (this.timer !== null) return
      this.cd = 60
      this.timer = setInterval(this.onTimer, 1000)
    },
    onTimer () {
      this.cd -= 1
      if (this.cd === 0) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    onInputChange (e) {
      const value = this.model = e.target.value
      this.$emit('change', value)
    },
    onBlur () {
      this.$emit('blur', this.model)
    }
  }
}
</script>
